import Link from "next/link";

/* One consent / notice line to sit directly under a form's submit button.
 * Never a pre-checked box: it states what happens when the form is sent. */

type Kind = "newsletter" | "contact" | "account" | "order" | "chat" | "lead" | "inquiry";

const TEXT: Record<Kind, string> = {
  newsletter:
    "By subscribing you agree to receive our email newsletter and occasional offers from Apex Flow Labs. Unsubscribe with one click in any email.",
  lead:
    "We use your email to send what you asked for and to follow up with related emails and offers. Unsubscribe with one click in any email.",
  contact: "We use your name, email and message only to answer you.",
  inquiry: "We use these details to answer your inquiry and prepare a quote. We do not sell them.",
  account: "We use your email to run your account and send receipts, download links and security notices.",
  order:
    "Your email is used to send your receipt and download link. Digital download only: nothing ships. Payment is handled by Stripe.",
  chat:
    "This is an AI assistant, not a person. Do not type card numbers, passwords or health or other sensitive details. Messages are processed by our AI provider and kept to improve the service.",
};

export function FormConsentNote({
  kind,
  className = "",
}: {
  kind: Kind;
  className?: string;
}) {
  return (
    <p className={`text-[12px] leading-[1.5] text-white/80 ${className}`}>
      {TEXT[kind]}{" "}
      <Link href="/legal/privacy" className="underline underline-offset-2">
        Privacy Policy
      </Link>
      .
    </p>
  );
}
